import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { NEWS } from "../lib/content";

export default function Noticias() {
  return (
    <>
      <section className="pt-28 md:pt-36 pb-12 bg-white">
        <div className="sca-container">
          <Reveal>
            <p className="sca-overline mb-6">[ Notícias · Conteúdo técnico ]</p>
            <h1 className="sca-h1 max-w-[20ch]">
              Decisões técnicas exigem <span className="sca-serif text-sca-red">conteúdo técnico</span>.
            </h1>
            <p className="sca-body mt-8 max-w-2xl">
              A construção civil exige decisões técnicas. Este espaço existe para orientar essas decisões com
              artigos, análises e tendências para gestores de obra, indústrias e desenvolvedores.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="sca-section pt-10 bg-white">
        <div className="sca-container">
          <Stagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-sca-line border-t border-l border-sca-line">
            {NEWS.map((n) => (
              <StaggerItem key={n.slug}>
                <Link
                  to={`/noticias/${n.slug}`}
                  data-testid={`news-card-${n.slug}`}
                  className="block h-full"
                >
                  <article className="group bg-white border-r border-b border-sca-line h-full hover:bg-sca-black hover:text-white transition-colors duration-500">
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={n.image}
                        alt={n.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1400ms]"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-7 md:p-8">
                      <div className="flex items-center justify-between mb-5 text-[11px] tracking-[0.22em] uppercase font-bold">
                        <span className="text-sca-red">{n.tag}</span>
                        <span className="text-sca-steel group-hover:text-white/60">{n.date}</span>
                      </div>
                      <h3 className="font-sans text-xl md:text-2xl font-semibold leading-tight tracking-tight mb-4 group-hover:text-white">
                        {n.title}
                      </h3>
                      <p className="text-sm leading-relaxed text-sca-steel group-hover:text-white/70 mb-6">
                        {n.excerpt}
                      </p>
                      <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-sca-red">
                        Ler artigo <ArrowUpRight className="w-3.5 h-3.5" />
                      </span>
                    </div>
                  </article>
                </Link>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>
    </>
  );
}
